import React, { useRef } from 'react'
import Modal from '../_layouts/Modal'
import Button from '../_atoms/Button/index'
import { useCoachDashboard } from './CoachDashboardProvider'
import RichTextEditor from '~/lib/ui/rich-text-editor'
import Quill from 'quill'

const CancelMeetingModal = ({ open, meeting, onClose, onConfirm }) => {
  const { current_user } = useCoachDashboard()
  const editorRef = useRef(null)

  const firstName = meeting?.candidate?.split(' ')[0] || ''

  const defaultMessage = {
    ops: [
      {
        insert: `Hi ${firstName},\n\nI'm so sorry, but I need to cancel this meeting. I'd love to meet with you soon so please take a look at my calendar on your Connect with Your Coach page at your earliest convenience. Again, my sincere apologies, and I look forward to meeting with you a different day.\n\nWarm regards,\nCoach ${current_user.first_name}`,
      },
    ],
  }
  const quillTemp = document.createElement('div')
  const quillInstance = new Quill(quillTemp)
  quillInstance.setContents(defaultMessage)

  const handleConfirm = (e) => {
    e.preventDefault()
    if (meeting) {
      onConfirm(meeting, editorRef?.current?.getSemanticHTML())
    }
    window.location.reload()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Cancel Meeting"
      size="sm"
      actions={[
        <Button key="cancel" variant="ghost" onClick={onClose}>
          Close
        </Button>,
        <Button
          key="confirm"
          variant="solid"
          color="primary"
          type="submit"
          onClick={handleConfirm}
        >
          Confirm
        </Button>,
      ]}
    >
      <div>
        <p>
          Are you sure you want to cancel the{' '}
          <strong>{meeting?.service_request}</strong> with{' '}
          <strong>{meeting?.candidate}</strong>? Do not take this action to mark
          this meeting as a No-Show.
        </p>
        <label className="mb-2 mt-4 block text-sm font-medium">
          Please write a message to the candidate explaining the cancellation
          below before confirming.
        </label>
        <RichTextEditor
          className="h-[425px]"
          defaultValue={defaultMessage}
          ref={editorRef}
        />
      </div>
    </Modal>
  )
}

export default CancelMeetingModal
